import { useEffect, useState } from "react";
import ButtonComponent from "../../../components/common/button/Button"
import Modal from "../../../components/common/modal/Modal";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { toast } from "react-toastify";
import { WorkFlowEditApprovers, WorkFlowEditApproversFooter } from "../WorkflowManagement/WorkFLowEditApproversModal";
import { totalApproverListEndpoint } from "../../../common/endpoints";
import { getTotalApproverList } from "../../../redux/actions/TotalApproverListSlice";
import { useDispatch, useSelector } from "react-redux";

export const EditApproversModalNew = ({ rowCount, runOutputSeqId, disableEditApproversButton, editApproversAPI, selectedSinglePlant, setBulkPDTDisabled, setBulkPDTValue }) => {

    //Modal content props below
    const [openEditApprovers, setOpenEditApprovers] = useState(false);
    const [disableAddApprovalButton, setDisableAddApprovalButton] = useState(true);
    const [allUsers, setAllUsers] = useState([]);
    const { instance } = useMsal();
    const dispatch = useDispatch();

    useEffect(() => {
        if (rowCount > 0) {
            getAllUser()
        }
        getCurrentApprovers();
    }, [openEditApprovers])

    const getAllUser = async () => {
        const account = instance?.getAllAccounts()[0];
        instance?.setActiveAccount(account);
        const tokenRequest = {
            scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
        };
        const response = await instance?.acquireTokenSilent(tokenRequest);
        const accessToken = response?.accessToken;


        const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/lt/approvers`;
        axios.get(url,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    withCredentials: true
                },
                params: {
                    plant: selectedSinglePlant?.[0] || localStorage.getItem("selectedLTPlantCode"),
                    userEmail: localStorage.getItem("data"),
                    ltRole: localStorage.getItem("LTRole"),
                    cdRole: localStorage.getItem("CDRole"),
                    ltRegion: localStorage.getItem("LTRegion")
                }
            }
        )
            .then(response => {
                const loggedInUserEmail = localStorage.getItem("data");
                const filteredUsers = response?.data?.filter(user => user.email !== loggedInUserEmail);

                setAllUsers(filteredUsers)
            })
            .catch(error => {
                console.error('Error fetching the data:', error);
            });
    }

    const getCurrentApprovers = async () => {
        if (!runOutputSeqId) return;
        try {
            const responseTotalApprovers = await dispatch(getTotalApproverList({
                dynamicEndpoint: `${totalApproverListEndpoint}/${runOutputSeqId}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode"),
                }
            }));

            if (responseTotalApprovers.meta.requestStatus === 'fulfilled') {
                const approvers = responseTotalApprovers?.payload?.map(item => {
                    return {
                        level: item.level,
                        name: item.approverName,
                        email: item.approverEmail
                    }
                })
                setRows(approvers);
                setMinApprovalLevels(responseTotalApprovers?.payload?.length);
            } else {
                toast.error(responseTotalApprovers?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error(error, {
                autoClose: 2000,
            });
        }

    }

    const initialData = [
        { level: 1, name: '', email: '' }
    ];
    const [rows, setRows] = useState(initialData);
    const [minApprovalLevels, setMinApprovalLevels] = useState(1);
    const [key, setKey] = useState(0);


    const handleAddRow = () => {
        const newLevel = rows.length + 1;
        setRows([...rows, { level: newLevel, name: '', email: '' }]);
        setDisableAddApprovalButton(true);
    };

    const loggedinUser = localStorage.getItem("data");
    const allNamesFilled = rows.every(row => row.name !== '' && row.email !== loggedinUser);
    const handleDeleteRow = (index) => {
        const newRows = rows.filter((_, rowIndex) => rowIndex !== index);
        // Reassign levels
        const updatedRows = newRows.map((row, rowIndex) => ({
            ...row,
            level: rowIndex + 1
        }));
        setRows(updatedRows);
        setKey(prevKey => prevKey + 1); // Force re-render
    };
    const handleChangeApprover = (index, event, value) => {
        const newRows = [...rows];
        newRows[index]['name'] = value ? value.name : '';
        newRows[index]['email'] = value ? value.email : '';
        setRows(newRows);
        setDisableAddApprovalButton(false)
    };

    const onClickEditApproversButton = () => {
        setRows(initialData)
        setOpenEditApprovers(true);
    };
    const closeEditApproversModal = () => {
        setRows(initialData)
        setOpenEditApprovers(false);

    };
    const callEditApproversAPI = () => {
        const filterRows = rows.filter(item => item.name);
        setOpenEditApprovers(false);
        editApproversAPI(filterRows);
        if (typeof setBulkPDTDisabled === 'function') {
            setBulkPDTDisabled(true);
        }
        if (typeof setBulkPDTValue === 'function') {
            setBulkPDTValue("");
        }
    };

    return (
        <>
            <ButtonComponent
                maxWidth="200px"
                label={"Edit Approvers"}
                bgColor="black"
                color="white"
                onClick={onClickEditApproversButton}
                disabled={disableEditApproversButton}
            />
            <Modal
                className="editApproversContent_cls"
                open={openEditApprovers}
                handleClose={closeEditApproversModal}
                title="Edit Approvers"
                action={
                    <WorkFlowEditApproversFooter
                        submitLabel="Save"
                        disableSubmitButton={!allNamesFilled}
                        sendForEditApproversAPI={callEditApproversAPI}
                    />
                }
                content={
                    <WorkFlowEditApprovers
                        className="editApproversContent_cls"
                        disableAddApprovalButton={disableAddApprovalButton}
                        data={allUsers}
                        addApprover={handleAddRow}
                        onHandleDeleteIcon={handleDeleteRow}
                        key={key}

                        handleChangeApprover={handleChangeApprover}
                        allUsers={allUsers}
                        rows={rows}
                        allNamesFilled={allNamesFilled}
                        minApprovalLevels={minApprovalLevels}
                    />
                }
                maxWidth="100px"
            />
        </>
    )
}